export default { sha: 'e2fdc46e4df560d74ff0054326d34798db04ba06', buildNumber: 'undefined' }
